import React from "react";

export const SERVICE_TERMINATED_MESSAGE =
  "This service is terminated and currently unavailable to users. Kindly reach out to the Veterinary Council of Nigeria for your questions.\n\nThank you.";

const ServiceTerminated = () => (
  <div
    role="alert"
    style={{
      alignItems: "center",
      background: "#f7f7f7",
      color: "#1f2d3d",
      display: "flex",
      fontFamily: "'Open Sans', Arial, sans-serif",
      justifyContent: "center",
      minHeight: "100vh",
      overflowY: "auto",
      padding: "24px",
      width: "100%",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        background: "#ffffff",
        borderTop: "4px solid #1a7f37",
        borderRadius: "8px",
        boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
        maxWidth: "640px",
        padding: "40px 32px",
        textAlign: "center",
        width: "100%",
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Veterinary Council of Nigeria"
        style={{ height: "72px", marginBottom: "24px", objectFit: "contain" }}
        onError={(event) => {
          event.currentTarget.style.display = "none";
        }}
      />
      <h1 style={{ fontSize: "24px", fontWeight: 700, margin: "0 0 16px" }}>
        Service unavailable
      </h1>
      <p style={{ fontSize: "17px", lineHeight: 1.65, margin: 0, whiteSpace: "pre-line" }}>
        {SERVICE_TERMINATED_MESSAGE}
      </p>
    </div>
  </div>
);

export default ServiceTerminated;
